import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {MonkeysGoldSoundConfig} from "./MonkeysGoldSoundConfig";
import {INolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {MonkeysGoldGameAssets} from "./MonkeysGoldGameAssets";
import {MonkeysGoldGameModuleConfig} from "./MonkeysGoldGameModuleConfig";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {MonkeysGold} from "./MonkeysGold";
import {MonkeysGoldGameConfig} from "./MonkeysGoldGameConfig";
import {MonkeysGoldReelSymbol} from "./symbols/MonkeysGoldReelSymbol";


export class MonkeysGoldPromoPanelConfig implements PromoPanelGameConfiguration {
    constructor() {
    }


    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "MonkeysGold",
            hasActionSpin: true,
            graphics: {backgroundTextureName: MonkeysGoldGameAssets.MAIN_GAME_BACKGROUND},
            getParsedData: (response: any, bet: number, prevResponse: any): ASWinData => {
                const parsedData: ASWinData = {
                    totalWin: response.accumulatedRoundWin,
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpinTriggered(response),
                    totalSpinWinnings: this.getSpinWin(response, bet, prevResponse),
                    isBigWin: this.isBigWin(response),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: response.brokeTheBank,

                }
                return parsedData;
            }
        };
    }

    public onActionSpinPlaySound(trigger: ActionSpinSound): void {
        if (trigger == ActionSpinSound.WIN) {
            (<INolimitAudioPlayer>SlotGame.sound).playTrack({name: (MonkeysGoldSoundConfig.instance.AS_WIN)})
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            (<INolimitAudioPlayer>SlotGame.sound).playTrack({name: (MonkeysGoldSoundConfig.instance.AS_WIN_BIG)})
        }
    }

    onPlayBonusInGame(data: any): void {
        const reels: string[][] = data.evaluatedArea;
        let sym: StateReelSymbol;
        for (let i: number = 0; i < reels.length; i++) {
            for (let j: number = 0; j < reels.length; j++) {
                sym = (Reels.getSymbol(i, j)!);
                sym.replaceWith(reels[i][j], i);
                (sym as MonkeysGoldReelSymbol).resetAnimations();
                if (sym.symName === "X") {
                    sym.setVisibility(false);
                }
            }
        }
        MonkeysGoldGameModuleConfig.monkeysGoldScatterLandView.cleanUpAllScatters();
        EventHandler.dispatchEvent(new GameEvent("STOP_INDIVIDUAL_WIN_FROM_AS"));
        SlotGame.keypad.setWin(data.accumulatedRoundWin, true);
        setTimeout(() => {
            EventHandler.dispatchEvent(new GameEvent(ServerEvent.GAME_DATA_RECEIVED, data));
            EventHandler.dispatchEvent(new GameEvent(ScreenEvent.GAME_START));
        }, 1000);
    }

    private isBigWin(response: any): boolean {
        let win = response.totalBetWayWinnings;

        if (response.wasFeatureBuy) {
            const betPrice = MonkeysGoldGameModuleConfig.featurePrice.getBuyFeaturePriceAS(response);
            let winRatio: number = Helper.ceilToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }

        let winRatio: number = Helper.ceilToDecimals((win / response.playedBetValue), 2);
        return winRatio >= 15;
    }

    private getSpinWin(response: any, bet: number, prevData: any): number {
        return response.totalBetWayWinnings;
    }

    private isFreeSpinTriggered(response: any): boolean {
        return (response.mode === GameMode.NORMAL || response.mode === GameMode.NORMAL_AVALANCHE) && response.nextMode === GameMode.FREESPIN;
    }

    private getFeatureName(response: any): string {
        if (response.mode == GameMode.FREESPIN || response.nextMode == GameMode.FREESPIN || response.mode == GameMode.FREESPIN_AVALANCHE || response.nextMode == GameMode.FREESPIN_AVALANCHE) {
            return "MONKEY'S GOLD FREESPINS";
        }
        return response.mode;
    }

    private isRoundComplete(response: any): boolean {
        return ([GameMode.FREESPIN, GameMode.NORMAL].indexOf(response.nextMode) > -1);
    }

    private isBonusEnd(response: any): boolean {
        return ((response.nextMode === GameMode.NORMAL) && (response.mode === GameMode.FREESPIN || response.mode === GameMode.FREESPIN_AVALANCHE));
    }
}